import {
  Box,
  Badge,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useDisclosure,
} from "@chakra-ui/react";
import NotificationList from "../common/NotificationList";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo, memo } from "react";
import { GetNotifications } from "../../redux/modules/account";
import { toastrMsg } from "../../utils/toastrMsg";
import Vector from "../../assets/images/Vector1.svg";

const Notifications = () => {
  const { Notifications } = useAppSelector((state) => ({
    Notifications: state.account.Notifications,
  }));
  let navigate = useNavigate();
  let dispatch = useAppDispatch();
  const {
    isOpen: isNotificationOpen,
    onOpen: onNotificationOpen,
    onClose: onNotificationClose,
  } = useDisclosure();

  const handleClick = (item: any) => {
    onNotificationClose();
    const qs = item?.id ? `?notificationId=${encodeURIComponent(item.id)}` : "";
    if (item?.type === "Transaction") {
      navigate(`/transactions/transactiondetails/${item.referenceId}${qs}`);
      return;
    }
    navigate(`/support/my-tickets/${item.referenceNumber}${qs}`);
  };

  useEffect(() => {
    const getNotifications = async () => {
      let res: any = await dispatch(GetNotifications({ unreadOnly: true }));
      if (res.error) {
        toastrMsg("Error", res.error.message);
      }
    };
    getNotifications();
  }, [dispatch]);

  const memoizedNotifications = useMemo(() => {
    return Notifications?.map((item: any) => ({
      ...item,
      description: item.description || "New reply on ticket",
    }));
  }, [Notifications]);

  return (
    <>
      {Notifications?.length > 0 && (
        <Box alignItems="center">
          <Popover
            trigger="click"
            placement="bottom-start"
            isOpen={isNotificationOpen}
            onClose={onNotificationClose}
          >
            <PopoverTrigger>
              <Badge
                cursor="pointer"
                position="relative"
                bg="#fff"
                width="30px"
                marginRight="10px"
                borderRadius="5px"
                onClick={onNotificationOpen}
              >
                <img src={Vector} alt="Notifications" />
                <span className="notification-count">
                  {Notifications?.length}
                </span>
              </Badge>
            </PopoverTrigger>
            {isNotificationOpen && (
              <PopoverContent
                minWidth={{ base: "calc(100vw - 24px)", md: "340px" }}
                maxW={{ base: "calc(100vw - 24px)", md: "340px" }}
                zIndex="999999"
                bg="white"
                _focus={{ boxShadow: "none" }}
                boxShadow="xl"
                borderRadius="lg"
                overflow="hidden"
              >
                <PopoverBody padding="0px" boxShadow="none">
                  <NotificationList
                    notifications={memoizedNotifications}
                    onItemClick={handleClick}
                    manageHref="/notifications"
                  />
                </PopoverBody>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      )}
    </>
  );
};

export default memo(Notifications);
